import RandomString from "randomstring";
const options = {
	length: 5,
	charset: "alphabetic",
	capitalization: "uppercase",
};

const referenceGenerator = (phonenumber) => {
	return `KA-${phonenumber}-${RandomString.generate(options)}`;
};

export default referenceGenerator;
